/*
 * Title: Leaderboard/AllFansContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: All Fans page content
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import Loader from "@components/Loader";
import FullName from "@components/FullName";
import { numberFormat, currencyFormat } from "@helpers/common";
import { useSelector } from "react-redux";
import CallbackService from "@services/callback-service";
import LinkTo from "@components/LinkTo";

const animations = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 },
};
type Props = {};

const AllfansContent: React.FC<Props | any> = (props) => {
  const creator = useSelector((state: any) => (state.creator));
  const programId = creator?.program?.id;

  let page = 1;
  let take = 10;

  React.useEffect(() => {
     const params = {
      take:take,
      page:page
     }
     props.fetchLeaderboards(programId, params);
  }, []);

  const loadMore = () => {
    const params = {
      take:take,
      page:(props?.meta?.page || 0) +1
     }
    props.fetchLeaderboards(
      programId,
      params
    );
  };

  const cname = creator?.creator?.username;
  const pname = creator.program.name

  return (
    <div className="relative">
      <div
        className="overflow-x-hidden overflow-y-auto tabs-height-leader"
        id="scrollbar">
        <motion.div
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.5 }}>
          {/* all fans leaders listing  */}
          <div className="space-y-3 overflow-auto pt-8 pr-3 pb-[150px] sm:pb-[160px]">
            {(props.data || []).map((item, index) => {
              var bg =
                index === 0
                  ? "blue-gradient"
                  : index === 1
                  ? "golden-gradient"
                  : index === 2
                  ? "silver-gradient"
                  : "bg-[#000]/50";
              return (
                <div
                 className="bg-tile py-5 px-4 rounded-[10px] relative"
                  key={index}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-x-3">
                      <div
                        className={`${bg} rounded-full lg:w-[25px] lg:h-[25px] w-6 h-6 flex items-center justify-center`}>
                        <p className="tile-inlay-primary lg:text-[14px] text-[10px]">
                          {numberFormat(index + 1)}
                        </p>
                      </div>
                      <p className="font-medium tile-inlay-primary lg:text-[18px] text-[14px]">
                        {item?.displayName}
                      </p>
                    </div>
                    <p className="text-base font-medium tile-inlay-primary">
                      {numberFormat(item?.lifetimeScore || 0)}
                    </p>
                  </div>
                </div>
              );
            })}
            {
              // props.data.length >= (index===0 ? limit:limit*index) &&
              props.data?.length >= 0 && props.meta?.hasNextPage && (
                <div className="flex justify-content-center">
                  <button
                    disabled={props.isFetching}
                    onClick={() => loadMore()}
                    className={` bg-btn hover:opacity-80 rounded-full mx-auto h-[42px] w-[89px] font-medium text-[18px] btn-inlay-primary`}>
                    {props.isFetching ? (
                      <Loader height={30} width={30} white={true} />
                    ) : (
                      "more"
                    )}
                  </button>
                </div>
              )
            }
          </div>
        </motion.div>

        {/* section absolute at bottom all the time start*/}
        <div className="fixed lg:hidden sm:absolute bottom-action h-[150px] max-w-full w-full transition-all duration-300 ease-in-out text-center left-0 right-0 pl-3 pr-8 py-2 space-y-3">
          <div className="bg-tile py-5 px-4 space-y-2 mt-3 relative rounded-[10px]">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-x-3">
                <div className="rounded-full lg:w-[25px] lg:h-[25px] w-6 h-6 flex items-center justify-center bg-[#000]/50">
                  <p className="tile-inlay-primary lg:text-[14px] text-[10px]">
                    {(props.score?.fans_rank || 0)}
                  </p>
                </div>
                <p className="font-medium tile-inlay-primary lg:text-[18px] text-[14px]">
                <FullName />
                </p>
              </div>
              <p className="text-base font-medium tile-inlay-primary">
                {numberFormat(props.score?.lifetime_points || 0)}
              </p>
            </div>
          </div>

          <LinkTo
            to={`/${cname}/${pname}/earn`}
            text="earn points"
            className="flex items-center justify-center text-[18px] font-medium btn-inlay-primary bg-btn rounded-full w-[150px] h-[42px] mx-auto"
          />
        </div>
        {/* section absolute at bottom all the time end*/}
      </div>
    </div>
  );
};

const mapStateToProps = ({ leaderboard, user, creator, score }) => {
  return {
    data: leaderboard.data,
    meta: leaderboard.meta,
    user: user.user,
    isFetching: leaderboard.isFetching,
    score:score
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { actions } = require("@redux/LeaderBoardRedux");
  return {
    ...stateProps,
    fetchLeaderboards: (programId, params) => {
      actions.fetchLeaderboards(dispatch, programId, params);
    },
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(AllfansContent);
